import {isEmpty, str_replace} from "../helpers/helpers";
import {array_unique, inArray, is_array} from "../helpers/arrays";

export const handleDealTypeParams = (states, deal_type, types) => {
    let fields = [];
    let more_field_count = 0;
    if (!isEmpty(deal_type) && !isEmpty(dealTypeParams[deal_type])) {
        const params = dealTypeParams[deal_type];
        fields = fields.concat(params['general']);
        fields = fields.concat(params['more']);
        more_field_count = params['more'].length;

        if (types.length) {
            for (let key in types) {
                let type = types[key];

                if (type.indexOf('.') !== -1) {
                    const mergedTypes = type.split('.');
                    type = mergedTypes[0];
                }

                if (typeof params[type] !== "undefined" && params[type].length) {
                    fields = fields.concat(params[type]);
                    if (more_field_count === 0) {
                        more_field_count = 1;
                    }
                }
            }
        }
    }

    return handleVisibleFilters(fields, more_field_count, states);
};

export const handleVisibleFilters = (fields, more_field_count, states) => {
    for (let index in states) {
        if (!isEmpty(states[index]) && index !== 'selected_filters') {
            states[index]['show'] = false;

            if (!fields.length) {
                states[index]['selected_range'] = {
                    min: null,
                    max: null
                }
            }
        }
    }

    if (more_field_count > 0) {
        states['more']['show'] = true;
    }

    if (fields.length) {
        for (let key in fields) {
            let field = fields[key];
            if (typeof states[field] !== "undefined") {
                states[field]['show'] = true;
            }
        }
    }

    return states;
};

export const checkVisibleFilter = (deal_type, types, field) => {
    let searchFieldArrays = [];
    let generalFields = [];

    const params = dealTypeParams[deal_type];
    if (!isEmpty(params)) {
        generalFields = generalFields.concat(params['general']);
        generalFields = generalFields.concat(params['more']);
    }

    if (!isEmpty(types) && is_array(types) && types.length) {
        for (let key in types) {
            let type = types[key];

            if (type.indexOf('.') !== -1) {
                const mergedTypes = type.split('.');
                type = mergedTypes[0];
            }

            let typeSearchFields = generalFields;

            if (!isEmpty(params) && !isEmpty(params[type]) && params[type].length) {
                typeSearchFields = typeSearchFields.concat(params[type]);
                searchFieldArrays.push(typeSearchFields);
            }
        }
    } else {
        searchFieldArrays.push(generalFields);
    }


    let searchFields = [];
    if (searchFieldArrays.length > 0) {
        // combine array of arrays to one shared item array
        searchFields = searchFieldArrays.shift().reduce(function (res, v) {
            if (res.indexOf(v) === -1 && searchFieldArrays.every(function (a) {
                return a.indexOf(v) !== -1;
            })) res.push(v);
            return res;
        }, []);
    }

    return (searchFields.length && inArray(field, searchFields));
};

export const handleFiltersCount = (data, type = '') => {
    let selectedFilters = [];
    let index;

    for (index in data) {
        if (data.hasOwnProperty(index) && data[index]) {
            if (index.indexOf("min") >= 0 || index.indexOf("max") >= 0) {
                index = str_replace('min_', '', index);
                index = str_replace('max_', '', index);
            }

            if (index === 'bedrooms' && data[index] === 0) {
                continue;
            }
            selectedFilters.push(index);
        }
    }

    selectedFilters = array_unique(selectedFilters);
    let countSelectedFilters = selectedFilters.length;

    let globalIgnoredFilters = [
        'q', 'sort', 'users_ids', 'archived', 'show', 'selected_range',
        'categories', 'categories[my_properties]',
        'categories[owner]', 'categories[coworker]',
        'is_special_page', 'selected_items', 'show',
    ];

    if (inArray('facilities', selectedFilters)) {
        globalIgnoredFilters = [...globalIgnoredFilters, ...['one_unit_in_floor', 'without_landlord']];
    }

    let desktopIgnoredFilters = [
        'city_id', 'district_id',
        'types', 'deal_type', 'villa_types',
        'price', 'mortgage', 'rent',
        'loan', 'selected_items', 'show',
        'has_media', 'has_video'
    ];

    let desktopIgnoredFiltersCount = 0;
    desktopIgnoredFilters = desktopIgnoredFilters.concat(globalIgnoredFilters);

    for (index in desktopIgnoredFilters) {
        let item = desktopIgnoredFilters[index];
        if (selectedFilters.indexOf(item) !== -1) {
            desktopIgnoredFiltersCount += 1;
        }
    }

    let globalIgnoredFiltersCount = 0;
    for (index in globalIgnoredFilters) {
        let item = globalIgnoredFilters[index];
        if (selectedFilters.indexOf(item) !== -1) {
            globalIgnoredFiltersCount += 1;
        }
    }

    const desktopFiltersCount = Math.max((countSelectedFilters - desktopIgnoredFiltersCount), 0);
    const mobileFiltersCount = Math.max((countSelectedFilters - globalIgnoredFiltersCount), 0);

    if (type === 'mobile') {
        return mobileFiltersCount;
    } else if (type === 'desktop') {
        return desktopFiltersCount;
    } else {
        return {
            desktop: desktopFiltersCount,
            mobile: mobileFiltersCount
        }
    }
};


export const dealTypeParams = {
    sale: {
        general: ['price'],
        more: [],
        apartment: ['deeds', 'exchangeable', 'infrastructure_area', 'bedrooms', 'floors', 'age', 'unit_per_floor', 'loan'],
        house: ['deeds', 'exchangeable', 'infrastructure_area', 'bedrooms', 'land_area', 'floors', 'age', 'densities'],
        commercial: ['deeds', 'exchangeable', 'infrastructure_area'],
        land: ['deeds', 'exchangeable', 'land_area', 'densities'],
        office: ['deeds', 'exchangeable', 'infrastructure_area', 'bedrooms', 'floors', 'age'],
        villa: ['deeds', 'exchangeable', 'infrastructure_area', 'bedrooms', 'land_area', 'age', 'villa_type', 'has_pool'],
        garden: ['deeds', 'exchangeable', 'land_area'],
        suite: ['deeds', 'exchangeable', 'infrastructure_area', 'floors', 'age', 'loan'],
        residential_complex: ['deeds', 'exchangeable', 'infrastructure_area', 'bedrooms', 'floors', 'age', 'unit_per_floor'],
        hotel: ['deeds', 'exchangeable', 'infrastructure_area', 'land_area', 'floors', 'age'],
        apartment_hotel: ['deeds', 'exchangeable', 'infrastructure_area', 'land_area', 'floors', 'age'],
        salon: ['deeds', 'exchangeable', 'land_area'],
        warehouse: ['deeds', 'exchangeable', 'infrastructure_area', 'land_area'],
        workhouse: ['deeds', 'exchangeable', 'infrastructure_area', 'land_area'],
        factory: ['deeds', 'exchangeable', 'infrastructure_area', 'land_area'],
        old_house: ['deeds', 'exchangeable', 'land_area', 'densities'],
        realestate: ['deeds', 'exchangeable', 'infrastructure_area', 'bedrooms', 'floors', 'age', 'unit_per_floor'],
    },
    rent: {
        general: ['rent', 'mortgage'],
        more: [],
        apartment: ['infrastructure_area', 'bedrooms', 'floors', 'unit_per_floor'],
        house: ['infrastructure_area', 'bedrooms', 'floors'],
        commercial: ['infrastructure_area'],
        office: ['infrastructure_area', 'bedrooms', 'floors'],
        suite: ['infrastructure_area', 'floors'],
        villa: [],
        garden: [],
        residential_complex: [],
        hotel: [],
        apartment_hotel: [],
        salon: [],
        warehouse: [],
        workhouse: [],
        factory: [],
        land: [],
        old_house: [],
        realestate: [],
    },
    mortgage: {
        general: ['mortgage'],
        more: [],
        apartment: ['infrastructure_area', 'bedrooms', 'floors', 'unit_per_floor'],
        house: ['infrastructure_area', 'bedrooms', 'floors'],
        commercial: ['infrastructure_area'],
        office: ['infrastructure_area', 'bedrooms', 'floors'],
        suite: ['infrastructure_area', 'floors'],
        villa: [],
        garden: [],
        residential_complex: [],
        hotel: [],
        apartment_hotel: [],
        salon: [],
        warehouse: [],
        workhouse: [],
        factory: [],
        land: [],
        old_house: [],
        realestate: [],
    },
    pre_sale: {
        general: ['price'],
        more: [],
        apartment: ['deeds', 'infrastructure_area', 'bedrooms', 'floors', 'unit_per_floor'],
        commercial: ['deeds', 'infrastructure_area'],
        office: ['deeds', 'infrastructure_area', 'bedrooms', 'floors'],
        villa: ['deeds', 'infrastructure_area', 'bedrooms', 'land_area', 'villa_type', 'has_pool'],
        suite: ['deeds', 'infrastructure_area', 'floors'],
        residential_complex: ['deeds', 'infrastructure_area', 'bedrooms', 'floors', 'unit_per_floor'],
        house: ['deeds',],
        land: ['deeds',],
        garden: ['deeds',],
        hotel: ['deeds',],
        apartment_hotel: ['deeds',],
        salon: ['deeds',],
        warehouse: ['deeds',],
        workhouse: ['deeds',],
        factory: ['deeds',],
        old_house: ['deeds'],
        realestate: ['deeds', 'infrastructure_area', 'bedrooms', 'floors', 'unit_per_floor'],
    },
    exchange: {
        general: ['price'],
        more: [],
        apartment: ['deeds', 'infrastructure_area', 'bedrooms', 'floors', 'age', 'unit_per_floor'],
        house: ['deeds', 'infrastructure_area', 'bedrooms', 'land_area', 'floors', 'age', 'densities'],
        commercial: ['deeds', 'infrastructure_area'],
        land: ['deeds', 'land_area', 'densities'],
        office: ['deeds', 'infrastructure_area', 'bedrooms', 'floors', 'age'],
        villa: ['deeds', 'infrastructure_area', 'bedrooms', 'land_area', 'age', 'villa_type', 'has_pool'],
        garden: ['deeds', 'land_area'],
        suite: ['deeds', 'infrastructure_area', 'floors', 'age'],
        residential_complex: ['deeds', 'infrastructure_area', 'bedrooms', 'floors', 'age', 'unit_per_floor'],
        hotel: ['deeds', 'infrastructure_area', 'land_area', 'floors', 'age'],
        apartment_hotel: ['deeds', 'infrastructure_area', 'land_area', 'floors', 'age'],
        salon: ['deeds', 'land_area'],
        warehouse: ['deeds', 'infrastructure_area', 'land_area', 'age'],
        workhouse: ['deeds', 'infrastructure_area', 'land_area', 'age'],
        factory: ['deeds', 'infrastructure_area', 'land_area', 'age'],
        old_house: ['deeds', 'land_area', 'densities'],
        realestate: ['deeds', 'infrastructure_area', 'bedrooms', 'floors', 'age', 'unit_per_floor'],
    },
    participation: {
        general: ['price'],
        more: [],
        apartment: ['deeds', 'infrastructure_area', 'bedrooms', 'land_area', 'floors', 'age', 'unit_per_floor', 'loan'],
        commercial: ['deeds', 'infrastructure_area', 'land_area', 'age'],
        office: ['deeds', 'infrastructure_area', 'bedrooms', 'land_area', 'floors', 'age'],
        villa: ['deeds', 'infrastructure_area', 'bedrooms', 'land_area', 'age', 'villa_type', 'has_pool'],
        residential_complex: ['deeds', 'infrastructure_area', 'bedrooms', 'land_area', 'floors', 'age', 'unit_per_floor', 'loan'],
        house: ['deeds', 'densities'],
        land: ['deeds', 'densities'],
        garden: ['deeds',],
        suite: ['deeds',],
        hotel: ['deeds',],
        apartment_hotel: ['deeds',],
        salon: ['deeds',],
        warehouse: ['deeds',],
        workhouse: ['deeds',],
        factory: ['deeds',],
        old_house: ['deeds', 'densities'],
        realestate: ['deeds', 'infrastructure_area', 'bedrooms', 'land_area', 'floors', 'age', 'unit_per_floor', 'loan'],
    }
};
